import React from 'react';
import PropTypes from 'prop-types';

// own components
import EngineAnswerFieldFooter from "../EngineAnswerFieldFooter";
import EngineAnswerFieldEditButton from "../EngineAnswerFieldEditButton";
import EngineAnswerFieldChangesLogView from "../EngineAnswerFieldChangesLogView";
import ListOptionView from "./ListOptionView";

// custom components
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from "components/Card/CardFooter.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// core components
import Collapse from "@material-ui/core/Collapse";

const ListUniqueFieldAnswerView = ({answerData, editable, changeToEditable,
                                     toggleLogChangesView, logChangesViewMode, questionAnswerUpdateLogs}) => {
  return (
    <Card>
      <CardBody>
        <GridContainer>
          <GridItem xs={editable ? 10 : 12}>
            <ListOptionView
              options={answerData.answer.config.options}
              selected={answerData.answer.ListUniqueFieldAnswer}
            />
          </GridItem>

          {editable ? (
            <GridItem xs={2}>
              <EngineAnswerFieldEditButton
                changeToEditable={() => changeToEditable(answerData)}
                toggleLogChangesView={() => toggleLogChangesView(answerData)}
              />
            </GridItem>
          ) : (
            []
          )}
          <Collapse in={logChangesViewMode}>
            <EngineAnswerFieldChangesLogView
              questionAnswerUpdateLogs={questionAnswerUpdateLogs}
            />
          </Collapse>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <EngineAnswerFieldFooter answerData={answerData} />
      </CardFooter>
    </Card>
  );
};

ListUniqueFieldAnswerView.propTypes = {
  answerData: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  changeToEditable: PropTypes.func,
  toggleLogChangesView: PropTypes.func
};

export default ListUniqueFieldAnswerView;
